/**
 * Actions Types
 */

export enum FotoDocumentosTypes {
  SET_ANEXOS = '@refin/fotoDocumentos/SET_ANEXOS',
  DELETE_ANEXO = '@refin/fotoDocumentos/DELETE_ANEXO',
  SET_IS_DONE = '@refin/fotoDocumentos/SET_IS_DONE',
  SET_IS_LOADING = '@refin/fotoDocumentos/SET_IS_LOADING',
  SET_IS_ERROR = '@refin/fotoDocumentos/SET_IS_ERROR',
  SEND_TO_S3_SAGA = '@refin/fotoDocumentos/SEND_TO_S3_SAGA',

  SET_ROLLBACK_ROUTER_ERROR = '@refin/fotoDocumentos/SET_ROLLBACK_ROUTER_ERROR',
  RESET = 'RESET',
}

export interface BlobsType {
  height: number
  width: number
  data: string
}

export interface Anexo {
  anexo: {
    id: string
    nome: string
    tipoExtensao: string
    size?: number
    blobs: BlobsType[]
  }
  tipo: string
}

export interface S3Type {
  tipo: string
  anexos: Anexo[]
  callbackError?: () => void
}

export interface Base64DocType {
  base64: string
  encrypted: string
  type: string
}

/**
 * State Type
 */

export interface FotoDocumentosState {
  readonly anexos: Anexo[]
  readonly isDone: boolean
  readonly isLoading: boolean
  readonly isError: boolean
  readonly rollbackRouterError: string
  readonly indice: number
}
